module.exports = {"museum":{"en":"/museum/:slug/:page?","fr":"/musee/:slug/:page?","component":"pages/museum/Museum"},"artwork":{"en":"/artwork/:id?/:page?","fr":"/oeuvre/:id?/:page?","component":"pages/artwork/Artwork"}}


//////////////////
// WEBPACK FOOTER
// ./src/Route.json
// module id = 9KGQ
// module chunks = 0